import Video from '../Video'

export function Reel() {
    return (
        <div id="reel">
        <Video />
        </div>
    )
}